import { type DateRangePickerValue } from '@apps/web/components/ui/date_range_picker';

const DATE_KEY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export function isValidDateKey(value: string): boolean {
    return DATE_KEY_REGEX.test(value);
}

export function shiftRangeStorageKey(organizationId: string): string {
    return `phoebe:shifts:selected-range:${organizationId}`;
}

export function serializeShiftRange(range: DateRangePickerValue): string {
    return `${range.from}|${range.to}`;
}

export function parseShiftRange(
    value: string | null,
): DateRangePickerValue | null {
    if (!value) {
        return null;
    }

    const [from, to] = value.split('|');
    if (from && to && isValidDateKey(from) && isValidDateKey(to)) {
        return { from, to };
    }
    return null;
}

export function resolveInitialShiftRange(args: {
    readonly from?: string;
    readonly to?: string;
    readonly date?: string;
    readonly storedRange: DateRangePickerValue | null;
    readonly todayKey: string;
}): DateRangePickerValue {
    const { from, to, date, storedRange, todayKey } = args;

    if (from && to && isValidDateKey(from) && isValidDateKey(to)) {
        return from <= to ? { from, to } : { from: to, to: from };
    }
    if (date && isValidDateKey(date)) {
        return { from: date, to: date };
    }
    if (storedRange) {
        return storedRange;
    }
    return { from: todayKey, to: todayKey };
}

export function isTodayRange(
    range: DateRangePickerValue,
    todayKey: string,
): boolean {
    return range.from === todayKey && range.to === todayKey;
}

export function isRangeEntirelyInPast(
    range: DateRangePickerValue,
    todayKey: string,
): boolean {
    return range.to < todayKey;
}
